module.exports = __webpack_public_path__ + "imgs/star-full-yellow.709b9409c64a67ded56cc03b5f9d01c8.svg";